<button matTooltip="Save as default map" color="primary" mat-mini-fab (click)="saveMap()" *ngIf="!(saving | async)">
  <mat-icon>save</mat-icon>
</button>
<button mat-mini-fab color="primary" *ngIf="saving | async">
  <mat-progress-spinner mode="indeterminate" color="accent" diameter="25"></mat-progress-spinner>
</button>

